import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "sonner";

import AppLayout from "./components/layout/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Connections from "./pages/Connections";
import WebServices from "./pages/WebServices";
import N8nPage from "./pages/N8nPage";
import BrowserPage from "./pages/BrowserPage";
import KraiApiPage from "./pages/KraiApiPage";
import GatewayPage from "./pages/GatewayPage";
import EnginesPage from "./pages/EnginesPage";
import SessionsPage from "./pages/SessionsPage";
import AiModelsPage from "./pages/AiModelsPage";
import ProvidersPage from "./pages/ProvidersPage";
import SettingsPage from "./pages/SettingsPage";
import SystemPage from "./pages/SystemPage";

import "@/App.css";

function Protected({ children }) {
  const { status } = useAuth();
  if (status === "checking") {
    return (
      <div className="min-h-screen bg-black text-zinc-500 grid place-items-center font-mono text-xs">
        Verificando sesión…
      </div>
    );
  }
  if (status === "anon") return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/connections" element={<Connections />} />
        <Route path="/web-services" element={<WebServices />} />
        <Route path="/n8n" element={<N8nPage />} />
        <Route path="/browser" element={<BrowserPage />} />
        <Route path="/krai-api" element={<KraiApiPage />} />
        <Route path="/gateway" element={<GatewayPage />} />
        <Route path="/engines" element={<EnginesPage />} />
        <Route path="/sessions" element={<SessionsPage />} />
        <Route path="/ai-models" element={<AiModelsPage />} />
        <Route path="/providers" element={<ProvidersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/system" element={<SystemPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#09090b",
              border: "1px solid #27272a",
              color: "#fafafa",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
